import Badge from '@mui/material/Badge';
import withStyles from '@mui/styles/withStyles';

const StyledBadge = withStyles((theme) => ({
  badge: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
}))(Badge);

export default StyledBadge;
